if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.storage = new WIQStorage("wiq-bundle-builder");
      }

      onSubmitHandler(evt) {
  evt.preventDefault();

  // FIXED GIFT CARD HANDLING
  if (this.hasAttribute("data-gift-card")) {
    const productId = this.dataset.giftCard;
    const formData = new FormData(this.form);
    const variantId = formData.get("id");
    
    // Build properties object
    let properties = {};
    for (let [key, value] of formData.entries()) {
      if (key.startsWith("properties[")) {
        let propName = key.match(/^properties\[(.*)\]$/);
        if (propName && propName[1]) {
          properties[propName[1]] = value;
        }
      }
    }
    
    // Get existing local items
    var localItems = this.storage.get() || [];
    
    // FIXED: Check for existing item with same productId AND variantId AND properties
    const existingIndex = localItems.findIndex(item => 
      item.productId == productId && 
      item.variantId == variantId &&
      JSON.stringify(item.properties || {}) === JSON.stringify(properties)
    );
    
    if (existingIndex > -1) {
      // Same exact gift card (same variant and properties) - increment quantity
      localItems[existingIndex].quantity = parseInt(localItems[existingIndex].quantity) + parseInt(formData.get("quantity") || 1);
    } else {
      // Different gift card variant or properties - add as new item
      localItems.unshift({
        productId: productId,
        variantId: variantId,
        quantity: parseInt(formData.get("quantity") || 1),
        properties: properties
      });
    }
    
    // Save to storage
    this.storage.set(localItems);
    
    // Redirect to bundle page
    window.location.href = window.routes.bundle_link;
    return;
  }

  // Original code for non-gift-card products continues below...
  if (this.submitButton.getAttribute("aria-disabled") === "true") return;

  this.handleErrorMessage();

  this.submitButton.setAttribute("aria-disabled", true);
  this.submitButton.classList.add("loading");
  this.querySelector(".loading__spinner").classList.remove("hidden");

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  const formData = new FormData(this.form);
  if (this.cart) {
    formData.append(
      "sections",
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append("sections_url", window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: formData.get("id"),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage =
          this.submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButtonText.classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      const startMarker = CartPerformance.createStartingMarker(
        "add:wait-for-subscribers"
      );
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: formData.get("id"),
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker(
            "add:wait-for-subscribers",
            startMarker
          );
        });
      this.error = false;
      const quickAddModal = this.closest("quick-add-modal");
      if (quickAddModal) {
        document.body.addEventListener(
          "modalClosed",
          () => {
            setTimeout(() => {
              CartPerformance.measure(
                "add:paint-updated-sections",
                () => {
                  this.cart.renderContents(response);
                }
              );
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        CartPerformance.measure("add:paint-updated-sections", () => {
          this.cart.renderContents(response);
        });
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove("loading");
      if (this.cart && this.cart.classList.contains("is-empty"))
        this.cart.classList.remove("is-empty");
      if (!this.error) this.submitButton.removeAttribute("aria-disabled");
      this.querySelector(".loading__spinner").classList.add("hidden");

      CartPerformance.measureFromEvent("add:user-action", evt);
    });
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
